import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const sectionStyle = {
  marginBottom: '16px',
  padding: '14px',
  backgroundColor: '#f8f9fa',
  borderRadius: '6px',
};

const headingStyle = {
  display: 'block',
  marginBottom: '8px',
};

function NotificationModal(props) {
  return (
    <Modal show={props.show} onHide={props.handleClose} scrollable>
      <Modal.Header closeButton>
        <Modal.Title>드림필라테스 이용관련 안내</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div
          className="NotificationModal"
          style={{ lineHeight: '1.8', fontSize: '15px' }}
        >
          <p style={{ marginBottom: '12px', fontWeight: '500' }}>
            안녕하세요. 드림필라테스 문래입니다.{' '}
            <span role="img" aria-label="미소">
              ☺️
            </span>
          </p>

          <p style={{ marginBottom: '12px' }}>
            10년이 넘는 시간 동안 드림필라테스와 함께한{' '}
            <strong>한송미 매니저가 8월 31일부로 퇴사</strong>하게 되었습니다.
          </p>

          <p style={{ marginBottom: '12px' }}>
            그동안 함께해주신 시간에 감사드리며, 앞으로는{' '}
            <strong>김수란 강사</strong>가 매니저 업무를 함께 맡아 회원님들의
            수업과 센터 이용에 불편함이 없도록 도와드리겠습니다.
          </p>

          <p style={{ marginBottom: '20px', color: '#626473' }}>
            김수란 강사 수업 시간 중에는 통화가 어려울 수 있으나 문자나 카톡을
            남겨주시면 빠른 시간 내에 확인 후 연락 드리겠습니다! 앞으로 잘 부탁
            드립니다.{' '}
            <span role="img" aria-label="미소">
              😊
            </span>
          </p>

          <p style={{ marginBottom: '16px' }}>
            아울러 원활한 센터 운영을 위해 변경된 사항에 대해 아래와 같이
            안내드리오니 이용에 참고 부탁드립니다.
          </p>

          <div style={sectionStyle}>
            <strong style={headingStyle}>1. 9월 그룹수업 이벤트 안내</strong>
            <div>9월 1일부터 30일까지 그룹수업 이벤트가 진행됩니다.</div>
            <div style={{ margin: '8px 0', fontWeight: '600' }}>
              그룹수업 9회 → 19만원
            </div>
            <div>신규 회원님과 기존 회원님 모두 이용 가능하며,</div>
            <div>지인 추천 이벤트도 함께 진행 중이오니</div>
            <div>소중한 지인과 함께 오셔서 즐겁게 운동하시길 바랍니다.</div>
          </div>

          <div style={sectionStyle}>
            <strong style={headingStyle}>2. 수업 스케줄 변경 안내</strong>
            <div style={{ marginBottom: '8px' }}>
              <strong>9월 14일부터</strong> 수업 스케줄에 변경사항이 있습니다.
            </div>
            <div>
              금요일 저녁 그룹레슨은 <strong>6시 / 7시 / 9시</strong>,
            </div>
            <div>
              임산부 그룹레슨 <strong>8시</strong>로 진행될 예정입니다.
            </div>
            <div style={{ marginTop: '8px' }}>
              토요일 오전 그룹레슨은 <strong>10시 / 11시</strong>,
            </div>
            <div>
              임산부 그룹 <strong>11시</strong>로 진행될 예정입니다.
            </div>
            <div style={{ marginTop: '8px' }}>
              수업 예약시 참고 부탁 드리겠습니다.
            </div>
          </div>

          <div style={sectionStyle}>
            <strong style={headingStyle}>3. 출석 이벤트 종료 안내</strong>
            <div>많은 사랑을 받아왔던 출석 이벤트가 종료됩니다.</div>
            <div style={{ marginTop: '8px' }}>
              그동안 출석 이벤트에 보내주신 많은 관심과 사랑에 진심으로
              감사드리며, 더 좋은 이벤트로 다시 찾아뵙겠습니다.{' '}
              <span role="img" aria-label="초록 하트">
                💚
              </span>
            </div>
          </div>

          <div style={{ ...sectionStyle, marginBottom: '20px' }}>
            <strong style={headingStyle}>4. 그룹수업 예약 및 취소 안내</strong>
            <div>9월 둘째 주부터는 원활한 수업 운영을 위해</div>
            <div>
              오전 수업은 <strong>전날 밤 10시까지</strong>,
            </div>
            <div>
              오후 수업은 <strong>당일 오전 10시까지</strong>
            </div>
            <div>예약이 없는 경우 폐강될 수 있습니다.</div>
            <div style={{ marginTop: '8px' }}>
              원하시는 수업이 있으신 경우,
            </div>
            <div>해당 시간 전까지 미리 예약 부탁드립니다.</div>
            <div style={{ marginTop: '8px' }}>
              또한 수업 취소는 <strong>수업 시작 12시간 전</strong>까지
              가능하며,
            </div>
            <div>참석이 어려우신 경우에는</div>
            <div>반드시 시간 내에 취소 부탁드립니다.</div>
            <div style={{ marginTop: '8px', color: '#d96055', fontWeight: '500' }}>
              (미취소 시 수업이 자동 차감됩니다.{' '}
              <span role="img" aria-label="아쉬운 표정">
                🥲
              </span>
              )
            </div>
          </div>

          <p style={{ marginBottom: '8px' }}>
            앞으로도 회원님들이 더욱 편안하게 운동하실 수 있도록 세심하게
            관리하고 좋은 수업으로 보답하겠습니다.
          </p>

          <p style={{ marginBottom: '0', fontWeight: '500' }}>
            감사합니다.{' '}
            <span role="img" aria-label="미소">
              ☺️
            </span>
            <br />
            드림필라테스 문래 드림{' '}
            <span role="img" aria-label="나뭇잎">
              🌿
            </span>
          </p>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={props.handleClose}>
          닫기
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default NotificationModal;
